// extracted by mini-css-extract-plugin
module.exports = {"LoaderContainer":"LoadingBar_LoaderContainer__lO9Q1","LoaderImage":"LoadingBar_LoaderImage__2iJaZ","Loader":"LoadingBar_Loader__2vxSk","spin":"LoadingBar_spin__3iYpl"};